export default __webpack_public_path__ + "static/media/happiness.63381f6a.svg";